.field {
  display: block;
  margin-bottom: var(--space-4);
}

.label {
  display: block;
  margin-bottom: 6px;
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--text);
}

.input {
  display: block;
  width: 100%;
  min-height: var(--touch-min);
  padding: 0 var(--space-3);
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-md);
  background: var(--surface-panel);
  color: var(--text);
  font: inherit;
  font-size: 17px;
  transition:
    border-color var(--dur) var(--ease-out),
    box-shadow var(--dur) var(--ease-out);
}

.input::placeholder {
  color: var(--text-subtle);
}

.input:hover {
  border-color: var(--text-muted);
}

.input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-tint);
}

.input:disabled {
  background: var(--surface-sunken);
  opacity: 0.7;
}

.input[aria-invalid='true'] {
  border-color: var(--danger);
}

.error {
  display: block;
  margin-top: 6px;
  font-size: var(--text-sm);
  color: var(--danger);
}

.hint {
  display: block;
  margin-top: 6px;
  font-size: var(--text-sm);
  color: var(--text-muted);
}
